<template>
	<div class="login-block">
		<div v-if="userIsLoggedIn" style="margin-top: 10px;">
			<a href="/dashboard" target="challenger" class="btn-login-customer">
				{{ t.loginButton }}
			</a>
		</div>

		<template v-else>
			<template v-if="showSignUp">
				<div class="block-title">
					{{ t.loginSignUpTitle }}
				</div>
				
				<div class="block-description" v-html="t.loginSignUpDescription" />

				<router-link v-slot="{ navigate }" :to="{name: 'registration'}" custom>
					<button class="btn-register" @click="location.href=customerLoginUrl">
						{{ t.loginSignUp }}<span class="points">+30</span>
					</button>
				</router-link>
			</template>

			<template v-if="showLoginButtons">
				<div class="block-title">
					{{ t.loginAlreadySignedUpTitle }}
				</div>

				<div class="block-description">
					{{ t.loginAlreadySignedUpDescription }}
				</div>

				<div class="login-buttons">
					<button v-if="settings.registration_type=='id'" class="btn-login-customer" @click="location.href=customerLoginUrl">
						{{ t.loginSignInCustomerButton }}
					</button>

					<router-link v-if="settings.registration_type=='phone'" v-slot="{ navigate }" :to="{name: 'phone-login', query: $route.query}" custom>
						<button class="btn-login-phone" @click="navigate">
							<FontAwesomeIcon icon="mobile-alt" />
							{{ t.loginSignInPhoneButton }}
						</button>
					</router-link>

					<button v-if="settings.fbAppId" type="button" class="btn-login-facebook" @click="login('facebook')">
						<template v-if="connectionStatus.facebook=='connecting'">
							<FontAwesomeIcon icon="spinner" spin />
							{{ t.genericConnecting }}
						</template>
						<template v-else>
							<FontAwesomeIcon :icon="['fab', 'facebook-f']" />
							{{ t.loginSignInFbButton }}
						</template>
					</button>

					<button v-if="settings.linkedinKey" type="button" class="btn-login-linkedin" @click="login('linkedin')">
						<template v-if="connectionStatus.linkedin=='connecting'">
							<FontAwesomeIcon icon="spinner" spin />
							{{ t.genericConnecting }}
						</template>
						<template v-else>
							<FontAwesomeIcon :icon="['fab', 'linkedin-in']" />
							Linkedin
						</template>
					</button>

					<button v-if="settings.googleId" type="button" class="btn-login-google" @click="login('google')">
						<template v-if="connectionStatus.google=='connecting'">
							<FontAwesomeIcon icon="spinner" spin />
							{{ t.genericConnecting }}
						</template>
						<template v-else>
							<FontAwesomeIcon :icon="['fab', 'google']" />
							Google
						</template>
					</button>

					<button v-if="settings.appleClientId" type="button" class="btn-login-apple" @click="login('apple')">
						<template v-if="connectionStatus.apple=='connecting'">
							<FontAwesomeIcon icon="spinner" spin />
							{{ t.genericConnecting }}
						</template>
						<template v-else>
							<FontAwesomeIcon :icon="['fab', 'apple']" />
							Apple
						</template>
					</button>
				</div>
			</template>
		</template>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from '@/js/stores/index';
import { useUserStore } from '@/js/stores/user';
import { authenticateOauth, processLoginError } from '@/js/includes/auth';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { $emit } from '@/js/includes/event-bus';
import { useRoute, useRouter } from 'vue-router';

const store = useStore()
const userStore = useUserStore()
const router = useRouter()
const route = useRoute()

// Props
const prop = defineProps({
	hideRegistration: {
		type: Boolean,
		default: false
	}
})

// Reactives
const location = window.location

// Computeds
const t = computed(() => store.translations)
const settings = computed(() => store.settings)
const showSignUp = computed(() => store.settings.ui.layoutShowSignupButton && !prop.hideRegistration)
const showLoginButtons = computed(() => !store.settings.ui.layoutShowSignupButton || store.isMobile)
const customerLoginUrl = computed(() => store.settings.customerLoginUrl)
const userIsLoggedIn = computed(() => userStore.loggedIn)
const connectionStatus = computed(() => userStore.connectionStatus)

// Functions
async function login(provider: string)
{
	try {
		await authenticateOauth(provider)
		$emit('login-successful')
	} catch(e) {
		processLoginError(e, provider, { router, route })
	}
}
</script>
